import { useState, useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import Privacy from './pages/Privacy'
import Terms from './pages/Terms'
import Success from './pages/Success'
import SetupPassword from './pages/SetupPassword'
import { getSpotsRemaining, getStats } from './utils/api'

function App() {
  const [spotsRemaining, setSpotsRemaining] = useState(20)
  const [stats, setStats] = useState({
    userCount: 0,
    reviewCount: 0,
    avgRating: 0
  })

  // Fetch initial data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [spots, statsData] = await Promise.all([
          getSpotsRemaining(),
          getStats()
        ])
        setSpotsRemaining(spots)
        setStats(statsData)
      } catch (error) {
        console.warn('Failed to fetch initial data:', error)
      }
    }
    
    fetchData()
  }, [])

  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/" element={<Home spotsRemaining={spotsRemaining} setSpotsRemaining={setSpotsRemaining} stats={stats} />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/success" element={<Success />} />
        <Route path="/setup-password" element={<SetupPassword />} />
      </Routes>
    </Router>
  )
}

export default App
